import { Customer } from '@squareup/sq-addons-web-sdk';

import {
  ENROLL_CUSTOMER,
  ENROLL_CUSTOMER_FULFILLED,
  ENROLL_CUSTOMER_REJECTED,
  ENROLL_CUSTOMER_STATE_RESET,
  ADD_CUSTOMER,
  ADD_CUSTOMER_TO_SALE,
  ADD_CUSTOMER_TO_SALE_FULFILLED,
  ADD_CUSTOMER_TO_SALE_REJECTED,
  GET_CUSTOMER,
  GET_CUSTOMER_FULFILLED,
  GET_CUSTOMER_REJECTED,
  GET_CUSTOMER_STATE_RESET,
  RESET_CUSTOMER,
  REMOVE_CUSTOMER_FROM_SALE,
  REMOVE_CUSTOMER_FROM_SALE_FULFILLED,
  REMOVE_CUSTOMER_FROM_SALE_REJECTED,
  SET_POINT_BALANCE,
  EnrollCustomerAction,
  EnrollCustomerFulfilledAction,
  EnrollCustomerRejectedAction,
  EnrollCustomerStateResetAction,
  AddCustomerAction,
  AddCustomerToSaleAction,
  AddCustomerToSaleFulfilledAction,
  AddCustomerToSaleRejectedAction,
  GetCustomerAction,
  GetCustomerFulfilledAction,
  GetCustomerRejectedAction,
  GetCustomerStateResetAction,
  ResetCustomerAction,
  RemoveCustomerFromSaleAction,
  RemoveCustomerFromSaleFulfilledAction,
  RemoveCustomerFromSaleRejectedAction,
  RequestContext,
  SetPointBalanceAction,
} from './';

export function enrollCustomer(phoneNumber: string): EnrollCustomerAction {
  return {
    type: ENROLL_CUSTOMER,
    payload: { phoneNumber },
  };
}

export function enrollCustomerFulfilled(): EnrollCustomerFulfilledAction {
  return {
    type: ENROLL_CUSTOMER_FULFILLED,
  };
}

export function enrollCustomerRejected(
  error: Error
): EnrollCustomerRejectedAction {
  return {
    type: ENROLL_CUSTOMER_REJECTED,
    payload: { error },
  };
}

export function enrollCustomerStateReset(): EnrollCustomerStateResetAction {
  return {
    type: ENROLL_CUSTOMER_STATE_RESET,
  };
}

export function addCustomer(
  customer: Customer,
  context: RequestContext
): AddCustomerAction {
  return {
    type: ADD_CUSTOMER,
    payload: { customer, context },
  };
}

export function addCustomerToSale(customer: Customer): AddCustomerToSaleAction {
  return {
    type: ADD_CUSTOMER_TO_SALE,
    payload: { customer },
  };
}

export function addCustomerToSaleFulfilled(): AddCustomerToSaleFulfilledAction {
  return {
    type: ADD_CUSTOMER_TO_SALE_FULFILLED,
  };
}

export function addCustomerToSaleRejected(
  error: Error
): AddCustomerToSaleRejectedAction {
  return {
    type: ADD_CUSTOMER_TO_SALE_REJECTED,
    payload: { error },
  };
}

export function resetCustomer(): ResetCustomerAction {
  return {
    type: RESET_CUSTOMER,
  };
}

export function removeCustomerFromSale(): RemoveCustomerFromSaleAction {
  return {
    type: REMOVE_CUSTOMER_FROM_SALE,
  };
}

export function removeCustomerFromSaleFulfilled(): RemoveCustomerFromSaleFulfilledAction {
  return {
    type: REMOVE_CUSTOMER_FROM_SALE_FULFILLED,
  };
}

export function setPointBalance(pointBalance: number): SetPointBalanceAction {
  return {
    type: SET_POINT_BALANCE,
    payload: { pointBalance },
  };
}

export function removeCustomerFromSaleRejected(
  error: Error
): RemoveCustomerFromSaleRejectedAction {
  return {
    type: REMOVE_CUSTOMER_FROM_SALE_REJECTED,
    payload: { error },
  };
}

export function getCustomer(
  context: RequestContext,
  referenceId?: string
): GetCustomerAction {
  return {
    type: GET_CUSTOMER,
    payload: { referenceId, context },
  };
}

export function getCustomerFulfilled(): GetCustomerFulfilledAction {
  return {
    type: GET_CUSTOMER_FULFILLED,
  };
}

export function getCustomerRejected(
  context: RequestContext,
  error: Error
): GetCustomerRejectedAction {
  return {
    type: GET_CUSTOMER_REJECTED,
    payload: { context, error },
  };
}

export function getCustomerStateReset(): GetCustomerStateResetAction {
  return {
    type: GET_CUSTOMER_STATE_RESET,
  };
}
